import React from 'react';
import styles from '../VideoAnalyzer.module.css';

const LoadingCard = ({ title, description, isLoaded }) => (
    <div className={styles.loadingCard}>
        <div className={styles.loadingIcon}>
            {isLoaded ? (
                <div style={{ color: '#38bdf8' }}>✓</div>
            ) : (
                <div className={styles.loadingSpinner} />
            )}
        </div>
        <div className={styles.loadingInfo}>
            <h4>{title}</h4>
            <p>{description}</p>
            {!isLoaded && (
                <div className={styles.loadingProgress}>
                    <div className={styles.loadingBar} />
                </div>
            )}
        </div>
    </div>
);

export default LoadingCard;